import { Button, InputForm } from '@components/index'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { AiOutlineClose } from 'react-icons/ai'

export interface data {
    index?: number
    title?: string
    description?: string
}

interface IProps {
    data?: data
    modelTitle: string
    labelTitle: string
    labelDescription: string
    appendChild: (values: data) => void
    updateChild: (index: number, values: data) => void
    closeModal: () => void
}

export default function RealEstateModal(props: IProps): React.ReactElement {
    const {
        handleSubmit,
        control,
        reset,
    } = useForm<data>()

    function formatDataModal(description: string): string {
        let aux = description.replace(/ {2,}/gm, ' ')
        aux = aux.replace(/^ +/gm, '')
        aux = aux.replace(/^ *[\n]/gm, '')

        return aux
    }

    function submit(values: data): void {
        if (values.description) {
            values.description = formatDataModal(values.description)
        }
        if (props.data?.index == undefined) {
            props.appendChild(values)
        } else {
            props.updateChild(props.data.index, values)
        }
        reset()
        props.closeModal()
    }

    return (
        <>
            {
                props.data ?
                    <div className='real-estate-modal' onClick={() => {
                        props.closeModal()
                        reset()
                    }}>
                        <div className='box-content-modal' onClick={(e) => e.stopPropagation()}>
                            <div className='header-modal'>
                                <h4>{props.modelTitle}</h4>
                                <button type='button' className='close-button' onClick={() => {
                                    props.closeModal()
                                    reset()
                                }
                                }>
                                    <AiOutlineClose className='button-close-icon' />
                                </button>
                            </div>
                            <form onSubmit={handleSubmit(submit)} className='form-modal'>
                                <Controller
                                    name="title"
                                    defaultValue={props.data?.title ?? ''}
                                    control={control}
                                    render={({ field: { value, onChange } }) => {
                                        return (
                                            <InputForm
                                                name="title"
                                                type="text"
                                                placeholder='Título'
                                                label={props.labelTitle}
                                                value={value}
                                                onChange={onChange}
                                                size='small'
                                            />
                                        )
                                    }}
                                />
                                <Controller
                                    name="description"
                                    defaultValue={props.data?.description ?? ''}
                                    control={control}
                                    render={({ field: { value, onChange } }) => {
                                        return (
                                            <InputForm
                                                name="description"
                                                type="text"
                                                placeholder="Descrição do apartamento"
                                                label={props.labelDescription}
                                                value={value}
                                                onChange={onChange}
                                                multiline
                                                rows={6.4}
                                                sx={{
                                                    '& .MuiInputBase-root': {
                                                        height: '10.362rem',
                                                        alignItems: 'flex-start',
                                                        boxSizing: 'border-box'
                                                    }
                                                }}
                                                size='small'
                                            />
                                        )
                                    }}
                                />
                                <div className='box-buttons'>
                                    <Button type="button" secondary placeholder={'Cancelar'} onClick={() => {
                                        props.closeModal()
                                        reset()
                                    }} />
                                    <Button type="submit" placeholder={'Adicionar'} />
                                </div>
                            </form>
                        </div>
                    </div>
                    :
                    <></>
            }
        </>
    )
}